export default __webpack_public_path__ + "locales/sq-AL/Common.json?hash=38262ed530db91dedf3f13442b0f3810";